export default [
    //{
    //    path: '*',
    //    meta: {
    //        public: true,
    //    },
    //    redirect: {
    //        path: '/404'
    //    }
    //},
    //{
    //    path: '/404',
    //    meta: {
    //        public: true,
    //    },
    //    name: 'NotFound',
    //    component: () => import(
    //        /* webpackChunkName: "routes" */
    //        `@/views/error/NotFound.vue`
    //    )
    //},
    {
        path: '/403',
        meta: {
            public: true,
        },
        name: 'AccessDenied',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/error/Deny.vue`
            )
    },
    {
        path: '/500',
        meta: {
            public: true,
        },
        name: 'ServerError',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/error/Error.vue`
            )
    },
    {
        path: '/login',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/Login.vue`
            )
    },
    {
        path: '/',
        meta: {breadcrumb: true},
        name: 'home',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/Home.vue`
            )
    },
    {
        path: '/dashboard',
        meta: {breadcrumb: true},
        name: 'dashboard',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/Home.vue`
            )
    },
    {
        path: '/profile',
        meta: {breadcrumb: true},
        name: 'Profile',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/account/Profile.vue`
            )
    },
    {
        path: '/updatePwd',
        meta: {breadcrumb: true},
        name: 'UpdatePwd',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/account/UpdatePwd.vue`
            )
    },
    {
        path: '/base/company',
        meta: {breadcrumb: true},
        name: 'Company',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Company.vue`
            )
    },
    {
        path: '/enterprise',
        meta: {breadcrumb: true},
        name: 'Enterprise',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Enterprise.vue`
            )
    },
    {
        path: '/base/corporation',
        meta: {breadcrumb: true},
        name: 'Corporation',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Corporation.vue`
            )
    },
    {
        path: '/check',
        meta: {breadcrumb: true},
        name: 'Check',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Check.vue`
            )
    },
    {
        path: '/star',
        meta: {breadcrumb: true},
        name: 'Star',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Star.vue`
            )
    },
    {
        path: '/news',
        meta: {breadcrumb: true},
        name: 'News',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/News.vue`
            )
    },
    {
        path: '/news/salon',
        meta: {breadcrumb: true},
        name: 'Salon',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/NewsSalon.vue`
            )
    },
    {
        path: '/news/study',
        meta: {breadcrumb: true},
        name: 'Study',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/NewsStudy.vue`
            )
    },
    {
        path: '/support',
        meta: {breadcrumb: true},
        name: 'Support',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Support.vue`
            )
    },
    {
        path: '/base/client',
        meta: {breadcrumb: true},
        name: 'Client',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Client.vue`
            )
    },
    {
        path: '/base/todo',
        meta: { breadcrumb: true },
        name: 'BaseTodo',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Todo.vue`
            )
    },
    {
        path: '/base/supplier',
        meta: {breadcrumb: true},
        name: 'Supplier',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Supplier.vue`
            )
    },
    {
        path: '/base/product',
        meta: {breadcrumb: true},
        name: 'Product',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Product.vue`
            )
    },
    {
        path: '/sales/order',
        meta: {breadcrumb: true},
        name: 'Order',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/order/Index.vue`
            )
    },
    {
        path: '/purchase/',
        meta: {breadcrumb: true},
        name: 'Purchase',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/purchase/Index.vue`
            )
    },
    {
        path: '/base/region',
        meta: {breadcrumb: true},
        name: 'Region',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Region.vue`
            )
    },
    {
        path: '/base/group',
        meta: {breadcrumb: true},
        name: 'Group',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/base/Group.vue`
            )
    },
    {
        path: '/system/user',
        meta: {breadcrumb: true},
        name: 'User',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/system/User.vue`
            )
    },
    {
        path: '/system/module',
        meta: {breadcrumb: true},
        name: 'Module',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/system/Module.vue`
            )
    },
    {
        path: '/system/role',
        meta: {breadcrumb: true},
        name: 'Role',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/system/Role.vue`
            )
    },
    {
        path: '/system/right',
        meta: {breadcrumb: true},
        name: 'Right',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/system/Right.vue`
            )
    },
    {
        path: '/system/log',
        meta: {breadcrumb: true},
        name: 'Log',
        component: () => import(
            /* webpackChunkName: "routes" */
            `@/views/system/Log.vue`
            )
    },
];
